import { CompanyClub } from '@domain/company-club';
import { useGenericQuery } from '@hooks/use-generic-query';
import { GenericQueryOptions } from '@hooks/use-generic-query.type';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants.type';

const getCompanyClub = async ({ companyId, clubSlug }: { companyId: string; clubSlug: string }) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/companies/${companyId}/clubs/${clubSlug}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetCompanyClub = (
  {
    companyId,
    clubSlug,
    options,
  }: {
    companyId: string;
    clubSlug: string;
    options?: GenericQueryOptions<CompanyClub, RequestError>;
  },
  hideError: boolean = true
) => {
  return useGenericQuery<CompanyClub, RequestError>(
    [QUERY_KEYS.getCompanyClub, companyId, clubSlug],
    () => getCompanyClub({ companyId, clubSlug }),
    options,
    hideError
  );
};
